@if (!isStepPrerequisiteCompleted()) {
  <app-previous-step-incomplete-notice></app-previous-step-incomplete-notice>
} @else {
  <p-card>
    <div class="p-6">
      <h2 class="text-2xl font-semibold mb-6">
        {{ 'project.steps.rfq.providerResult.title' | transloco }}
      </h2>

      <app-provider-results-table
        [projectId]="projectId"
        [phase]="TenderPhaseType.RFQ"
        [scoreBars]="true"
      />
    </div>
  </p-card>
}
